import { useChannelContext } from "@sendbird/uikit-react/Channel/context";

type ChannelContextValue = ReturnType<typeof useChannelContext>;

/**
 * Sendbird's `useChannelContext` throws when called outside a `<ChannelProvider>`.
 * In ops compose mode the `MessageInput` is rendered before a channel exists,
 * so we need to tolerate the missing provider without crashing.
 */
export function useSafeChannelContext(): ChannelContextValue | null {
  try {
    return useChannelContext();
  } catch {
    return null;
  }
}
